import { z } from "zod";

export const userMetaDataDataSchema = z.object({
  lastSignInTime: z.string(),
  creationTime: z.string(),
});

export type UserMetaData = z.infer<typeof userMetaDataDataSchema>;
